import {inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Observable} from 'rxjs';
import {PatientDto} from './dtos/patient.dto';
import {RegisterDto} from './dtos/register.dto';
import {AppointmentQueryDto} from './dtos/appointment-query.dto';
import {AppointmentDto} from '../../shared/dtos/appointment.dto';
import {AppointmentCancelDto} from './dtos/appointment-cancel.dto';
import {LocationDetailDto} from '../startup/dtos/location-detail.dto';
import {OnlineBookingUrlsQueryDto} from './dtos/online-booking-urls-query.dto';
import {OnlineBookingUrlDto} from './dtos/online-booking-url.dto';

@Injectable({
  providedIn: 'root'
})
export class PatientManagementService {
  http: HttpClient = inject(HttpClient);

  patientDto?: PatientDto;
  locationDetailDtos?: LocationDetailDto[];
  appointmentDtos?: AppointmentDto[];
  selectedAppointmentDto?: AppointmentDto;
  onlineBookingUrlDtos?: OnlineBookingUrlDto[];

  reset() {
    this.patientDto = undefined;
    this.locationDetailDtos = undefined;
    this.appointmentDtos = undefined;
    this.selectedAppointmentDto = undefined;
  }

  getPatient(patientId: number): Observable<PatientDto> {
    return this.http.get<PatientDto>(`${environment.cenplexBookingApiBaseUrl}/patients/${patientId}`);
  }

  updatePatient(patientDto: PatientDto): Observable<PatientDto> {
    return this.http.put<PatientDto>(`${environment.cenplexBookingApiBaseUrl}/patients/${patientDto.patientId}`, patientDto);
  }

  registerPatient(registerDto: RegisterDto): Observable<PatientDto> {
    return this.http.post<PatientDto>(`${environment.cenplexBookingApiBaseUrl}/patients/register`, registerDto);
  }

  queryAppointments(appointmentQueryDto: AppointmentQueryDto): Observable<AppointmentDto[]> {
    return this.http.post<AppointmentDto[]>(`${environment.cenplexBookingApiBaseUrl}/patients/${appointmentQueryDto.patientId}/appointments/query`, appointmentQueryDto);
  }

  cancelAppointment(appointmentCancelDto: AppointmentCancelDto): Observable<null> {
    return this.http.post<null>(`${environment.cenplexBookingApiBaseUrl}/appointments/${appointmentCancelDto.appointmentId}/cancel`, appointmentCancelDto);
  }

  hideAppointment(appointmentId: number): Observable<null> {
    return this.http.post<null>(`${environment.cenplexBookingApiBaseUrl}/appointments/${appointmentId}/hide`, {});
  }

  queryOnlineBookingUrls(onlineBookingUrlsQuery: OnlineBookingUrlsQueryDto): Observable<OnlineBookingUrlDto[]> {
    return this.http.post<OnlineBookingUrlDto[]>(`${environment.cenplexBookingApiBaseUrl}/online-booking-urls/query`, onlineBookingUrlsQuery);
  }
}
